module.exports = "data:image/jpeg;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICIuLi9pbWcvZW1zdGFycy5qcGciOw=="


//////////////////
// WEBPACK FOOTER
// ./src/_assets/img/emstars.jpg
// module id = 38
// module chunks = 0